enum BlendMode {
  Normal,
  Add,
  Multiply,
  Screen,
  Overlay,
  Darken,
  Lighten,
  ColorDodge,
  ColorBurn,
  HardLight,
  SoftLight
}

export default BlendMode;

export const BLEND_MODE_LABELS: string[] = [
  'Normal',
  'Add',
  'Multiply',
  'Screen',
  'Overlay',
  'Darken',
  'Lighten',
  'Color dodge',
  'Color burn',
  'Hard light',
  'Soft light'
];



// WEBPACK FOOTER //
// ./src/data/BlendMode.ts